import React, { FC } from 'react';
import PropTypes from 'prop-types';
import myImage from '../assets/logos/new_side_logo.png';


interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return (
		<div>
			<img src={myImage} alt='' style={{ width: width ? width : '100%' }} />
		</div>
	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
